import React, { useState } from "react";
import { Box, CircularProgress, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { useGetMoviesQuery } from "../../services/TMDB";
import { FeaturedMovie, MovieList, Pagination } from "..";

const Movies = () => {
  const [page, setPage] = useState(1);  //* Page Number state
  const { genreIdOrCategoryName, searchQuery } = useSelector((state) => state.currentGenreOrCategory);

  const { data, error, isFetching } = useGetMoviesQuery({ genreIdOrCategoryName, page, searchQuery });

  // Loader
  if (isFetching) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress size="4rem" />
      </Box>
    )
  }

  // if No result
  if (!data.results.length) {
    return (
      <Box display="flex" alignItems="center" mt="20px">
        <Typography variant="h4">
          No Movies that match that name.
          <br />
          Please search for something else.
        </Typography>
      </Box>
    )
  }

  // ! Error Handling
  if (error) {
    return 'An Error Occurred.';
  }

  return (<div>
    <FeaturedMovie movie={data.results[0]} />
    <MovieList movies={data} excludeFirst />
    <Pagination currentPage={page} setPage={setPage} totalPages={data.total_pages} />
  </div>);
};

export default Movies;
